import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import ListenPage from '@/components/ListenPage/ListenPage'
import MapPage from '@/components/MapPage'
import ExhibitPage from '@/components/ExhibitPage/ExhibitPage'
import PlasticPrimitivePage from '@/components/PlasticPrimitivePage'
import MorePage from '@/components/MorePage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/audio-tour',
      name: 'ListenPage',
      component: ListenPage
    },
    {
      path: '/map',
      name: 'MapPage',
      component: MapPage
    },
    {
      path: '/70x40x50',
      name: 'ExhibitPage',
      component: ExhibitPage
    },
    {
      path: '/plastic-primitive',
      name: 'PlasticPrimitivePage',
      component: PlasticPrimitivePage
    },
    {
      path: '/more',
      name: 'MorePage',
      component: MorePage
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js